<app-simple-modal [title]="'Usuarios'" [max]="80" [requiredFields]="false"
	(close)="close.emit($event)">
	<div fields>
		<h1 style="text-align: center;">{{companyName}}</h1>
		<div class="table-responsive">
			<table class="table table-stripped">
				<thead>
					<tr class="tr-middle">
						<th>ID</th>
						<th>Usuario</th>
						<th>Activo</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let user of users" class="tr-middle">
						<td>
							{{user.userId}}
						</td>
						<td>
							{{user.username}}
						</td>
						<td>
							{{user.isActive ? 'Activo': 'Inactivo'}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-simple-modal>